<template>
  <div id="input_delivery">
    <dd-header
      :headerSubContentType=1
      :headerTelContentType=1
    />
    <div id="container">
      <dd-sitemap
        :pageKey="pageKey"
        :pageList="topForm.pageList"
      />
      <div id="content">
        <div class="title">
          <h2>
            <label>事前現場調査先入力画面</label>
          </h2>
        </div>
        <div class="input_list">
          <dd-business-input
            ref="businessInputRef"
            :label="label"
            :form="form"
          />
          <ul>
            <li>
              <span>
                <label class="list_key">{{label.contactFlag}}</label>
                <label class="important">必須</label>
              </span>
              <div>
                <label>
                  <input type="radio" name="contact" :value="1" v-model="contactFlag">あり
                </label>
                <label>
                  <input type="radio" name="contact" :value="0" v-model="contactFlag">なし
                </label>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="Object.keys(errors).length > 0" class="error_text">入力内容にエラーがあります。項目をご確認の上、もう一度入力してください。</div>
        <div id="regist_btn">
          <router-link to="/mmstyle/top">
            <button class="main_btn cancel_btn">戻る</button>
          </router-link>
          <button class="main_btn" :disabled="!isConfirm" @click="confirm()" >現場調査情報入力</button>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'

import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import Calendar from '../../components/common/Calendar'
import LoadingModal from '../../components/common/LoadingModal'
// Module
import Header from '../components/common/DcHeader'
import SiteMap from '../components/common/SiteMap'
import BusinessInput from '../components/order/BusinessInput'

export default {
  name: 'OrderInput',
  components: {
    'dd-header': Header,
    'dd-sitemap': SiteMap,
    'dd-calendar': Calendar,
    'dd-loading-modal': LoadingModal,
    'dd-business-input': BusinessInput
  },
  props: {
    edit: Boolean
  },
  data () {
    return {
      pageKey: 'orderInput',
      form: {
        businessId: '',
        businessName: '',
        building: '',
        postcd: '',
        state: '',
        city: '',
        street: '',
        userLastName: '',
        userFirstName: '',
        userLastNameKana: '',
        userFirstNameKana: '',
        tel: '',
        deliveryDate: '',
        message: '',
        selectTime: 0,
        isRegistAddress: false
      },
      // 入力保持用のフォーム
      topForm: {},
      contactFlag: 1,
      // 画面表示項目
      label: {
        businessName: '施主名(物件名)',
        building: '調査物件名',
        address: '事前現場調査先住所',
        postcd: '事前現場調査先郵便番号',
        state: '住所',
        street: '以下、住所',
        userName: '立会人氏名',
        userNameKana: '立会人氏名（カナ）',
        tel: '立会人電話番号',
        contactFlag: '立会人への直接連絡',
        message: '配送時の連絡事項'
      },
      errors: {}
      // カレンダーの設定
      // schedule: {}
    }
  },
  methods: {
    // scheduling: function () {
    //   let payload = {
    //     params: {
    //       categoryId: this.topForm.categoryId
    //     }
    //   }
    //   axios.get(DC_URL.SCHEDULE + '/delivery', payload)
    //     .then(response => {
    //       this.schedule = response.data.data
    //     }).catch(error => {
    //       this.validateErrorMessages = {}
    //       Api.handleError(error, this.errorMessage, this.validateErrorMessages)
    //       this.$router.push('/mmstyle/error')
    //       this.$refs.loadingModalRef.showModal(false)
    //     })
    // },
    selectedDate: function (selectedDate) {
      let format = 'YYYY-MM-dd'.replace(/YYYY/g, selectedDate.getFullYear())
      format = format.replace(/MM/g, ('0' + (selectedDate.getMonth() + 1)).slice(-2))
      format = format.replace(/dd/g, ('0' + selectedDate.getDate()).slice(-2))
      this.form.deliveryDate = format
    },
    confirm: function () {
      this.$refs.loadingModalRef.showModal(true)
      // 入力チェック
      let retBusinessErr = this.$refs.businessInputRef.confirm()
      this.errors = {}
      this.validateRequire()
      if (!retBusinessErr || Object.keys(this.errors).length !== 0) {
        this.$refs.loadingModalRef.showModal(false)
        return
      }
      this.validateFormat()
      if (Object.keys(this.errors).length !== 0) {
        return
      }

      // 入力内容をストレージに格納
      let resrchForm = {
        resrchBusinessName: this.form.businessName,
        resrchBuilding: this.form.building,
        resrchPostcd: this.form.postcd,
        resrchState: this.form.state,
        resrchCity: this.form.city,
        resrchStreet: this.form.street,
        resrchTel: this.form.tel,
        resrchUserFirstName: this.form.userFirstName,
        resrchUserLastName: this.form.userLastName,
        resrchUserFirstNameKana: this.form.userFirstNameKana,
        resrchUserLastNameKana: this.form.userLastNameKana,
        contactFlag: this.contactFlag
      }
      App.setLocalStorage(DC_STORAGE_KEY.RESEARCH_DATA, resrchForm)
      // 配送料込みの値段を取得する
      let payload = {
        resrchBusinessName: this.form.businessName,
        resrchBuilding: this.form.building,
        resrchPostcd: this.form.postcd,
        resrchState: this.form.state,
        resrchCity: this.form.city,
        resrchStreet: this.form.street,
        resrchUserLastName: this.form.userLastName,
        resrchUserFirstName: this.form.userFirstName,
        resrchUserLastNameKana: this.form.userLastNameKana,
        resrchUserFirstNameKana: this.form.userFirstNameKana,
        resrchTel: this.form.tel
      }
      axios.post(DC_URL.ORDER + '/resrch', payload)
        .then(response => {
          if (response.data.errorMessage) {
            App.showModal({
              messages: [response.data.errorMessage]
            })
            this.$refs.loadingModalRef.showModal(false)
          } else {
            this.$router.push('/mmstyle/research/input')
          }
        }).catch(error => {
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.$router.push('/mmstyle/error')
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    fetchData: function () {
      let lform = App.getLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA)
      if (Object.keys(lform).length > 0) {
        this.form = Object.assign({}, lform)
      }
      let ltop = App.getLocalStorage(DC_STORAGE_KEY.TOP_FORM)
      if (Object.keys(ltop).length > 0) {
        this.topForm = Object.assign({}, ltop)
        this.$set(this.form, 'postcd', this.topForm.postcd)
        this.$set(this.form, 'state', this.topForm.state)
        this.$set(this.form, 'city', this.topForm.city)
        this.$set(this.form, 'street', this.topForm.street)
      }
      let lSelBusiness = App.getLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS)
      if (Object.keys(lSelBusiness).length > 0) {
        this.form = Object.assign(this.form, lSelBusiness)
      }
    },
    validateRequire: function () {
    },
    validateFormat: function () {
    }
  },
  computed: {
    isConfirm: function () {
      if (this.form.postcd && this.form.state && this.form.city) {
        return true
      }
      return false
    }
  },
  watch: {
  },
  mounted () {
    // this.scheduling()
  },
  created () {
    this.fetchData()
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/BuildingResearchBusiness.vue